import { get, sortBy } from 'lodash';
import React from 'react';
import ReactDOMServer from 'react-dom/server';

import LegendLabel from './LegendLabel';
import { GlobalToken } from 'antd';

export const getInitOptions = (token: GlobalToken) => ({
  chart: {
    backgroundColor: token.colorBgContainer,
    type: 'line',
    zoomType: 'x',
    panning: {
      enabled: true,
    },
    style: {
      fontFamily: 'Heebo',
    },
    panKey: 'alt',
    height: 400,
    spacingLeft: 20,
    spacingTop: 20,
    events: {
      selection: function (e) {
        // avoid handle selection of type "reset zoom"
        if (!e.xAxis) return;

        const {
          min,
          max,
          axis: { dataMin },
        } = e.xAxis[0];

        this.xAxis.forEach(axis => {
          axis.series.forEach(series => {
            // no need to reselect a visible series
            if (series.visible) return;

            const seriesDataMin = series.xData[0];
            const newMin = seriesDataMin + (min - dataMin);
            const newMax = seriesDataMin + (max - dataMin);

            axis.setExtremes(newMin, newMax);
          });
        });
      },
    },
  },
  boost: {},
  series: [],
  plotOptions: {
    series: {
      point: {
        events: {
          mouseOver: function () {
            const tickskArr = Object.values(this.series.xAxis.ticks);
            const tickskArrSorted = sortBy(tickskArr, ['pos']);
            this.selectedTick = tickskArrSorted.reverse().find((tick: { pos }) => tick.pos <= this.x);

            if (!this.selectedTick) return;

            this.selectedTick.label.css({
              color: token.colorPrimary,
            });
          },
          mouseOut: function () {
            if (this.selectedTick && this.selectedTick.label) {
              this.selectedTick.label.css({
                color: token.colorTextSecondary,
              });
            }
            this.selectedTick = null;
          },
        },
      },
      marker: {
        symbol: 'circle',
        enabled: false,
        states: {
          hover: {
            enabled: true,
            fillColor: token.colorBgContainer,
            lineWidth: 5,
            radius: 6,
          },
        },
      },
      turboThreshold: 10000,
    },
    line: {},
    area: {
      stacking: 'normal',
    },
  },
  legend: {
    enabled: true,
    align: 'right',
    verticalAlign: 'top',
    layout: 'vertical',
    x: 0,
    y: -17,
    navigation: {
      activeColor: token.colorText,
      inactiveColor: token.colorBorder,
      style: {
        color: token.colorText,
      },
    },
    labelFormatter() {
      const xData = get(this, 'xData', []);
      const startDate = xData[0];
      const endDate = xData[xData.length - 1];

      return ReactDOMServer.renderToString(
        <LegendLabel
          name={this.name}
          deviceName={this.options.deviceName}
          startDate={startDate}
          endDate={endDate}
          token={token}
        />,
      );
    },
    useHTML: true,
    itemStyle: {
      color: token.colorTextSecondary,
    },
    itemHoverStyle: {
      color: token.colorText,
    },
    itemHiddenStyle: {
      color: token.colorBorder,
    },
  },
  title: {
    text: null,
  },
  credits: {
    enabled: false,
  },
  time: {
    useUTC: false,
  },
  noData: {
    style: {
      fontSize: 16,
      fontWeight: 500,
      color: token.colorText,
      fontFamily: 'Heebo, sans-serif',
    },
  },
});
